import { UserCircleIcon } from "@heroicons/react/outline";
import { ConnectIcon } from "../icons/ConnectIcon";
import { HomeIcon } from "../icons/HomeIcon";
import { TeamsIcon } from "../icons/TeamsIcon";

export const navigationItems = [
  {
    name: "Home",
    href: "/app",
    icon: HomeIcon,
    current: (pathname) => pathname === "/app",
    eventDetails: {
      category: "General Navigation",
      action: "Home Viewed",
    },
  },
  {
    name: "Connect",
    href: "#",
    unavailable: true,
    icon: ConnectIcon,
    current: () => null,
    eventDetails: {
      category: "General Navigation",
      action: "Community Opened",
    },
  },
  {
    name: "Teams",
    href: "/app/teams",
    icon: TeamsIcon,
    current: (pathname) =>
      pathname === "/app/teams" || pathname === "/app/team/[slug]",
    eventDetails: {
      category: "General Navigation",
      action: "Choose Team Viewed",
    },
  },
  {
    name: "Profile",
    href: "/app/me",
    authenticated: true,
    icon: UserCircleIcon,
    current: (pathname) => pathname === "/app/member/[memberId]",
    eventDetails: {
      category: "General Navigation",
      action: "Profile Viewed",
    },
  },
];
